<template>
    <div class="a-p-floor-label" :id="isShowHereIcon ? $options.POSTER_FLOOR_ACTIVE_LABEL_ID: ''">
        <div
            v-if="floorNumber"
            class="a-p-floor-label__name"
            :style="componentStyle"
        >
            <span>{{$t(componentParams.plan, 'Plan')}} {{floorNumber}}</span>
        </div>
        <div 
            v-if="isShowHereIcon"
            class="a-p-floor-label__here"
        />
    </div>
</template>

<script>
import {POSTER_FLOOR_ACTIVE_LABEL_ID} from '../../../utils/constants/other'

export default {
    name: 'APFloorLabel',
    props: {
        componentStyle: {
            type: Object,
            default: () => ({})
        },
        componentParams: {
            type: Object,
            default: () => ({})
        },
        floorNumber: {
            type: [Number, null],
            default: null
        },
        isShowHereIcon: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if(this.isShowHereIcon) this.$emit('iconCreate')
    },
    POSTER_FLOOR_ACTIVE_LABEL_ID
}
</script>

<style lang="scss" src="./a-p-floor-label.scss" />
